// extracted by mini-css-extract-plugin
export default {"Link":"NavigationItem_Link__naYHq"};